/**
 * Manage Custom Countdown Timer
 */
class Countdown extends HTMLElement {
  constructor() {
    super();

    this.endDate = this.getAttribute('data-section_timer');
    if (this.endDate) {
      this.manageCountdown(this.endDate);
    }
  }

  /**
   * @param endDate fetching from customization
   */
  manageCountdown(endDate) {
    const tick = () => {
      const currentDate = Date.now();
      const startDateMilliseconds = new Date().getTime();
      const endDateMilliseconds = new Date(endDate).getTime();

      const difference = endDateMilliseconds - currentDate;
      const expired = difference < 0 ? 1 : 0;

      if (expired === 1 ) {
        this.classList.add('d-none');
        this.removeAttribute('data-start_date');
        return false;
      }

      const day = Math.floor(difference / 86400000);
      const hour = Math.floor((difference % 86400000) / 3600000);
      const min = Math.floor((difference % 3600000) / 60000);
      const sec = Math.floor((difference % 60000) / 1000);

      // Banner/hero always uses split-digit nodes; check those first so top bar badge markup never affects it.
      if (this.querySelector('[data-day_1]')) {
        const dStr = ('0' + day).slice(-2).split('');
        const hStr = ('0' + hour).slice(-2).split('');
        const mStr = ('0' + min).slice(-2).split('');
        const sStr = ('0' + sec).slice(-2).split('');

        if (this.querySelector('[data-day_1]')) this.querySelector('[data-day_1]').textContent = dStr[0];
        if (this.querySelector('[data-hour_1]')) this.querySelector('[data-hour_1]').textContent = hStr[0];
        if (this.querySelector('[data-min_1]')) this.querySelector('[data-min_1]').textContent = mStr[0];
        if (this.querySelector('[data-sec_1]')) this.querySelector('[data-sec_1]').textContent = sStr[0];

        if (this.querySelector('[data-day_2]')) this.querySelector('[data-day_2]').textContent = dStr[1];
        if (this.querySelector('[data-hour_2]')) this.querySelector('[data-hour_2]').textContent = hStr[1];
        if (this.querySelector('[data-min_2]')) this.querySelector('[data-min_2]').textContent = mStr[1];
        if (this.querySelector('[data-sec_2]')) this.querySelector('[data-sec_2]').textContent = sStr[1];
        return true;
      }

      const badgeDays = this.querySelector('[data-badge-days]');
      const badgeHours = this.querySelector('[data-badge-hours]');
      const badgeMins = this.querySelector('[data-badge-mins]');
      if (badgeDays && badgeHours && badgeMins) {
        badgeDays.textContent = String(day);
        badgeHours.textContent = String(hour);
        badgeMins.textContent = String(min);
      }
      return true;
    };

    tick();
    const countDownTimer = setInterval(() => {
      if (!tick()) {
        clearInterval(countDownTimer);
      }
    }, 1000);
  }
}
if (!customElements.get('custom-countdown')) {
  customElements.define('custom-countdown', Countdown);
}
